import type { OvercallingLastAction } from '../../hooks/useOvercallingDataEditingSession';

interface ConfirmationMessageProps {
  lastAction: OvercallingLastAction;
}

// Green (Keep) or red (Don't Keep) confirmation after a successful curation action.
// Messages per FR-030 / FR-031. Introduced by feature 009-overcalling-data-editing.
//
// Session 2026-05-28 (manual-test feedback): this now renders the CONTENT of the
// FR-030a auto-advance MASK overlay that covers the gray content container
// (OvercallingDataEditingPage). It shows the Keep / Don't-Keep outcome in large text plus a
// "Moving to next hand ..." line so it is unmistakable to the editor what happened and that
// the page is about to advance. Colors are tuned for the light mask background (client
// sign-off 2026-05-29, mirroring the Assign Level of Difficulty page).
//
// Session 2026-05-20 scope reduction: collapsed to hand-only wording. The
// "Problem is added to database." / "Problem is marked as 'deleted' in database."
// branches were removed because teaching problems are OUT OF SCOPE for curation.
export function ConfirmationMessage({ lastAction }: ConfirmationMessageProps) {
  if (!lastAction) return null;

  const isKeep = lastAction.kind === 'Keep';
  const message = isKeep
    ? 'Hand is added to database.'
    : "Hand is marked as 'deleted' in database.";

  return (
    <div className="text-center px-4">
      <div className={`text-2xl short:text-xl font-bold ${isKeep ? 'text-green-700' : 'text-red-700'}`}>
        {message}
      </div>
      <div className="mt-2 short:mt-1 text-lg short:text-base font-medium text-ink">
        Moving to next hand ...
      </div>
    </div>
  );
}
